(() => {
  const MENU_SELECTOR = '.pk-catalog-menu';
  const OPEN_CLASS = 'pk-catalog-menu--open';
  const CLOSE_DELAY = 200;

  function initializeCatalogMenus(root = document) {
    root.querySelectorAll(MENU_SELECTOR).forEach((menu) => {
      if (menu.dataset.pkCatalogReady === 'true') return;

      menu.dataset.pkCatalogReady = 'true';

      let closeTimer;

      const openMenu = () => {
        window.clearTimeout(closeTimer);
        menu.classList.add(OPEN_CLASS);
      };

      const scheduleClose = () => {
        window.clearTimeout(closeTimer);

        closeTimer = window.setTimeout(() => {
          menu.classList.remove(OPEN_CLASS);
        }, CLOSE_DELAY);
      };

      menu.addEventListener('pointerenter', openMenu);
      menu.addEventListener('pointerleave', scheduleClose);

      menu.addEventListener('focusin', openMenu);

      menu.addEventListener('focusout', (event) => {
        if (!menu.contains(event.relatedTarget)) {
          scheduleClose();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeCatalogMenus();
    });
  } else {
    initializeCatalogMenus();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeCatalogMenus(event.target);
  });
})();
